import * as React from 'react';
import { generateRoute, getFileVariant, translate } from '@js/common/helpers';
import { CustomFileVariantsEnum } from 'tagwalk-api-client/assets/js/Types/Enums';
var FreeReport = function (_a) {
    var report = _a.report, cdn = _a.cdn;
    return (React.createElement("div", { className: "list-item" },
        React.createElement("img", { className: "list-item-cover img-fluid", src: getFileVariant(report.cover.filename, CustomFileVariantsEnum.report_banner, cdn), alt: report.name }),
        React.createElement("div", { className: "list-item-details" },
            React.createElement("p", { className: "list-item-details-date" }, new Date(report.publication_date).toLocaleDateString()),
            React.createElement("h3", null, report.name),
            React.createElement("a", { href: generateRoute('newsletters_show', { 'slug': report.slug }), className: "list-item-btn" }, translate('report.get', {}, 'app')))));
};
export { FreeReport };
